import React from "react";
import {ExtLink} from "../style/itf-styled-components";

export const ExternalLink = ({className, to, children}) => (
  <ExtLink
    className={className}
    href={to}
    rel={!to.includes('facebook') ? 'noopener' : 'external'}
    target="_blank"
  >{children}</ExtLink>
);
